__turbopack_context__.v({
  "className": "caveat_9703d3d8-module__jHGTpa__className",
  "variable": "caveat_9703d3d8-module__jHGTpa__variable",
});
